import Link from 'next/link'
import { ChevronRightIcon } from 'lucide-react'

import { RightSideContent } from '~/ui/containers/base/base'
import { ConnectedAccountsRenderer } from '.'

export default function ConnectedAccountScreen() {
  return (
    <RightSideContent
      header={
        <div className="flex items-center">
          <Link href="/apps">
            <span className="hover:underline">Tools</span>
          </Link>
          <ChevronRightIcon
            height={12}
            width={12}
            strokeWidth={1.2}
            className="mx-[2px]"
            color="#2c2c2c80"
          />
          <span>Connected accounts</span>
        </div>
      }
    >
      <div className="px-4 pt-0">
        <ConnectedAccountsRenderer />
      </div>
    </RightSideContent>
  )
}
